import { useEffect } from 'react';
import { celebrateMatch } from '../lib/celebrate.js';

type Props = {
  show: boolean;
  word: string;
  phonetic: string | null;
  translationZh: string;
  onDone: () => void;
  durationMs?: number;
};

const STAR_POSITIONS = [
  { left: '20%', top: '30%' },
  { left: '78%', top: '24%' },
  { left: '15%', top: '68%' },
  { left: '82%', top: '72%' },
  { left: '50%', top: '12%' },
  { left: '50%', top: '88%' },
] as const;

export function MatchCelebration({
  show,
  word,
  phonetic,
  translationZh,
  onDone,
  durationMs = 1500,
}: Props): JSX.Element | null {
  useEffect(() => {
    if (!show) return;
    celebrateMatch();
    const t = window.setTimeout(onDone, durationMs);
    return () => clearTimeout(t);
  }, [show, durationMs, onDone]);

  if (!show) return null;
  return (
    <div
      role="status"
      aria-label="Match"
      className="fixed inset-0 z-50 pointer-events-none flex items-center justify-center animate-match-fade"
    >
      <div className="absolute inset-0 bg-canvas/75" />
      {STAR_POSITIONS.map((p, i) => (
        <div
          key={i}
          className="absolute text-[24px] text-primary animate-match-pop"
          style={{ left: p.left, top: p.top, animationDelay: `${i * 40}ms` }}
        >
          ✨
        </div>
      ))}
      <div className="relative flex flex-col items-center gap-2 max-w-card px-6">
        <div
          className="text-primary font-bold animate-match-pop"
          style={{ fontSize: '40px', lineHeight: '1' }}
        >
          BingGo!
        </div>
        <div className="text-secondary text-hint">记住了！</div>
        <div className="w-16 h-px bg-border my-3" />
        <div className="flex flex-col items-center gap-1 animate-match-detail-fade">
          <div className="text-word-lg text-primary">{word}</div>
          {phonetic ? <div className="text-ipa text-secondary">/{phonetic}/</div> : null}
          <div className="text-gloss text-primary mt-1 text-center">{translationZh}</div>
        </div>
      </div>
    </div>
  );
}
